import { type DataContainer, submitEvent, trackOnNextPageImpression, submitMerge } from "@otto-ec/tracking-bct";
import { TrackingBackendKeys, type TrackingLabels } from "../types/Websocket";

export class Tracking {
    BASE_TRACKING_DATA: DataContainer = {
        "wk.san_ActiveSearch": ["true"],
        "wk.san_SearchType": ["chatbot"],
    };

    /**
 *
 *
 */
    trackOnNextPageImpression(trackingData: DataContainer) {
        trackOnNextPageImpression(trackingData);
    }

    /**
 *
 */
    trackSubmitEvent(trackingData: DataContainer) {
        submitEvent(trackingData);
    }

    /*                                                    */
    submitMerge(trackingData: DataContainer) {
        submitMerge(trackingData);
    }

    trackPDPClick(sourceLabel: "link_pdp" | "link_pdp_advisory", backendLabels?: TrackingLabels, searchQuery?: string, productLinkType?: string) {
        const trackingData: DataContainer = this.getBaseTrackingData(backendLabels, searchQuery);
        trackingData["san_ChatBotInteraction"] = [sourceLabel];
        trackingData["wk.san_ChatBotAttribution"] = [sourceLabel];
        trackingData["wk.san_ProductType"] = ["organic"];
        if (productLinkType) {
            trackingData["wk.san_ProductLinkType"] = [productLinkType];
        }
        trackingData["wk.san_ProductClickListType"] = ["chatbot"];
        trackingData["san_Interaction"] = ["chatbot_product_tile"];
        tracking.trackOnNextPageImpression(trackingData);
    }

    trackProductListClick(backendLabels?: TrackingLabels, searchQuery?: string) {
        const trackingData: DataContainer = this.getBaseTrackingData(backendLabels, searchQuery);

        trackingData["san_ChatBotInteraction"] = ["link_list"];
        trackingData["wk.san_ChatBotAttribution"] = ["link_list"];
        trackingData["san_Interaction"] = ["chatbot_list"];

        tracking.trackOnNextPageImpression(trackingData);
    }

    getBaseTrackingData(backendLabels?: TrackingLabels, searchQuery?: string): DataContainer {
        const trackingData: DataContainer = { ...this.BASE_TRACKING_DATA };
        if (backendLabels) {
            for (const [key, value] of Object.entries(backendLabels)) {
                if (Object.values(TrackingBackendKeys).includes(key as TrackingBackendKeys)) {
                    trackingData[key] = [value]; /*                          */
                }
            }
        }
        if (searchQuery) {
            trackingData["wk.san_SearchTerm"] = [searchQuery];
            trackingData["wk.san_SearchWordCount"] = [searchQuery.split(" ").length.toString(10)];
        }
        return trackingData;
    }
}

export const tracking = new Tracking();
